import React from 'react';
import { Box, useTheme } from '@mui/material';
import { typewriter } from '@styles/animations';

import type { TypewriterCursorProps } from './StatusIndicator.types';

const CURSOR_WIDTHS = {
  sm: 2,
  md: 3,
  lg: 4,
};

const CURSOR_HEIGHTS = {
  sm: 12,
  md: 14,
  lg: 16,
};

/**
 * Blinking vertical cursor to indicate active streaming/typing
 */
export const TypewriterCursor: React.FC<TypewriterCursorProps> = ({ size = 'md', color }) => {
  const theme = useTheme();
  const cursorColor = color || theme.palette.chat.colors.streamingCursor;
  const cursorWidth = CURSOR_WIDTHS[size];
  const cursorHeight = CURSOR_HEIGHTS[size];

  return (
    <Box sx={{ display: 'flex', gap: 0.5, ml: 1, alignItems: 'center' }}>
      <Box
        sx={{
          width: cursorWidth,
          height: cursorHeight,
          borderRadius: 1,
          bgcolor: cursorColor,
          animation: `${typewriter} 0.8s infinite`,
          boxShadow: `0 0 8px ${theme.palette.chat.colors.statusShadow}`,
        }}
      />
    </Box>
  );
};
